<template>
  <div class="songcard p-shadow-1" :style="'background-color:' + bgColor">
    <h3 class="title">{{ screenTitle }}</h3>
    <div class="times">
      <p>{{ startStamp }}</p>
      <p>{{ endStamp }}</p>
    </div>
    <button class="rm" @click="rm">rm</button>
    <div class="tags">
      <span
        ><template v-for="item in tags" :key="item">
          <Chip class="chip p-mx-1" :label="item"></Chip> </template
      ></span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Chip from "primevue/chip";

export default defineComponent({
  name: "PreSongCard",
  components: { Chip },
  props: {
    screenTitle: {
      type: String,
      default: "",
    },
    start: {
      type: Number,
      default: 0,
    },
    end: {
      type: Number,
      default: 0,
    },
    tags: {
      type: Array,
      default: () => [],
    },
    videoId: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    num2stamp(time: number) {
      const h = Math.floor(time / 3600);
      const m = Math.floor((time % 3600) / 60);
      const s = Math.floor(time % 60);
      const hs = ("00" + h).slice(-2);
      const ms = ("00" + m).slice(-2);
      const ss = ("00" + s).slice(-2);
      return hs + ":" + ms + ":" + ss;
    },
    rm() {
      this.$emit("remove", this.index);
    },
  },
  computed: {
    startStamp(): string {
      return this.num2stamp(this.start);
    },
    endStamp(): string {
      return this.num2stamp(this.end);
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.songcard {
  width: 90%;
  max-width: 1020px;
  height: 90px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  margin-top: 16px;
}
img {
  position: absolute;
  top: 0;
  left: 0;
}
.chip {
  font-size: 8pt;
}
.title {
  font-size: 12pt;
}

.tags {
  text-align: left;
  padding-left: 16px;
}
h3 {
  padding-top: 0px;
  padding-left: 16px;
  text-align: left;
}
.times {
  position: absolute;
  font-size: 10pt;
  right: 80px;
  top: 8px;
}
.rm {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
</style>
